import "@/App.css";
import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import CareersPage from "./pages/CareersPage";
import IncubatorPage from "./pages/IncubatorPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

// Scroll to the top of the page on every route change, except:
//  - anchor links like /#ventures (let the target section handle the scroll)
//  - the careers job modal (/careers ↔ /careers/:slug), which keeps its
//    list position behind the overlay.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const prevPath = useRef(pathname);

  useEffect(() => {
    const from = prevPath.current;
    prevPath.current = pathname;
    if (hash) return;
    const inCareers = (p) => p.startsWith("/careers");
    if (inCareers(pathname) && inCareers(from)) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <ScrollToTop />
        <LanguageProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/incubator" element={<IncubatorPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/careers/:slug" element={<CareersPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
